export const environment = {
  production: true,
  apiUrl: "https://api-stg.alaga.ph/",
  watermark: 'NOT FOR PRODUCTION',
  watermarkMode: 'repeat', // 'repeat' or 'center'
  watermarkOpacity: 0.05,
  watermarkSize: '2.5rem',
  watermarkGap: 80,
  PWD_ID_FRONT : 25,
  PWD_ID_BACK : 28,
  SP_ID: 29,
  // GETPASS "Transport QR" card on the dashboard. Off where GETPASS is not part of the deployment.
  transportQrEnabled: true,
};

console.log = () => {};
console.error = () => {};
console.warn = () => {};
